import { toggleLoaderAsync } from "redux/loader";
import { getRequest, getRequestWithBlob } from "services/axiosBaseClient";
import moment from "moment-timezone";

export const getUpandDownEnergyReports =
  (evseIds, startTimeStamp, endTimeStamp, granularity, cb) =>
  async (dispatch) => {
    try {
      dispatch(toggleLoaderAsync(true));
      let url =
        "reports/energy-up-down?evseIds=" +
        evseIds +
        "&from=" +
        startTimeStamp +
        "&to=" +
        endTimeStamp +
        "&granularity=" +
        granularity +
        "&timezone=" +
        moment.tz.guess();

      // "report/energy-up-down?evseIds=69c1b1a2-bad1-415e-95cb-def0ce1a18d0,f70a6d37-5f96-4334-ba3b-6c3960f3c436&from=2022-08-01T00:00:00Z&to=2022-08-05T23:59:59Z&granularity=YYYY-MM-DD&timezone=America/Los_Angeles"
      await getRequest(url)
        .then((response) => {
          console.log("resresres", response);
          if (response.status === 200) {
            cb(
              Array.isArray(response.data.elements)
                ? response.data.elements
                : []
            );
            dispatch(toggleLoaderAsync(false));
          } else {
          }
        })
        .catch((e) => {
          console.log("error", e);
          cb([]);
          dispatch(toggleLoaderAsync(false));
          alert(e.message);
        });
    } catch (err) {
      throw new Error(err);
    }
  };

export const getUpandDownEnergyReportsDownload =
  (evseIds, startTimeStamp, endTimeStamp, granularity) => async (dispatch) => {
    try {
      console.log("evseIdsevseIdsevseIds", evseIds);
      dispatch(toggleLoaderAsync(true));
      let url =
        "reports/energy-up-down/download?evseIds=" +
        evseIds +
        "&from=" +
        startTimeStamp +
        "&to=" +
        endTimeStamp +
        "&granularity=" +
        granularity +
        "&timezone=" +
        moment.tz.guess();

      await getRequestWithBlob(url)
        .then((response) => {
          console.log("resresres", response);
          if (response.status === 200) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "file.csv");
            document.body.appendChild(link);
            link.click();
            dispatch(toggleLoaderAsync(false));
          } else {
          }
        })
        .catch((e) => {
          console.log("error", e);
          dispatch(toggleLoaderAsync(false));
        });
    } catch (err) {
      throw new Error(err);
    }
  };
